import { useCallback } from "react";
export var useToggleSelectAll = function (selectAllItems, unselectAllItems, totalItems, numSelected) {
    return useCallback(function () {
        if (numSelected === totalItems) {
            unselectAllItems === null || unselectAllItems === void 0 ? void 0 : unselectAllItems();
        }
        else {
            selectAllItems === null || selectAllItems === void 0 ? void 0 : selectAllItems();
        }
    }, [numSelected, selectAllItems, totalItems, unselectAllItems]);
};
//# sourceMappingURL=use-toggle-select-all.js.map